"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOTAL_PRODUCT_COUNT_FIELD = exports.TOTAL_CLASS_SKU_COUNT_FIELD = exports.DEFAULT_DESCENDANTS_FILTER_STRATEGY_MATRIX = exports.DEFAULT_ATTRIBUTES_FILTER_STRATEGY_MATRIX = void 0;
exports.DEFAULT_ATTRIBUTES_FILTER_STRATEGY_MATRIX = { isRequirement: true };
exports.DEFAULT_DESCENDANTS_FILTER_STRATEGY_MATRIX = { terminalNodesOnly: true };
exports.TOTAL_CLASS_SKU_COUNT_FIELD = 'totalClassSkuCount';
exports.TOTAL_PRODUCT_COUNT_FIELD = 'totalProductCount';
